
// src/actions/right-sidebar.js

export const OPEN_RIGHT_SIDE_PAGE = "OPEN_RIGHT_SIDE_PAGE"

export function openRightSidePage(name, params, push) {
  return {
    type: OPEN_RIGHT_SIDE_PAGE,
    name, params, push,
  }
}

export const CLOSE_RIGHT_SIDE_PAGE = "CLOSE_RIGHT_SIDE_PAGE"

export function closeRightSidePage(forced = false) {
  return {
    type: CLOSE_RIGHT_SIDE_PAGE, forced
  }
}




// WEBPACK FOOTER //
// ./src/actions/right-sidebar.js